import { AVSSubStatus } from "~/entities/AVS";

export default function (avsValue: any) {
  const errorMessageToAVSSubStatus: Record<string, AVSSubStatus> = {
    "street number or box number out of range": AVSSubStatus.outOfRange,
    "please provide a valid license key for this web service":
      AVSSubStatus.validLicenseKey,
    "please enter a valid address number.": AVSSubStatus.invalidAddress,
    "address not found": AVSSubStatus.addressNotFound,
    "street not found": AVSSubStatus.streetNotFound,
    "# unit not found": AVSSubStatus.unitNotFound,
    "no avs results returned": AVSSubStatus.noResultsReturned,
  };
  if (avsValue.errorCode > 0 && avsValue.errorMessage) {
    const key = String(avsValue.errorMessage).trim().toLowerCase();
    const avsSubStatus = errorMessageToAVSSubStatus[key];
    if (avsSubStatus) {
      return avsSubStatus;
    }
    return AVSSubStatus.apiAVSFailed;
  } else {
    return AVSSubStatus.apiAVSFailed;
  }
}
